import React, { useState } from "react";
import styled from "styled-components";
import {
    Input,
    Button,
    Spinner,
    Card,
    CardBody,
    Container,
    Row,
    Col,
} from "reactstrap";
import apiClient from "../../../apiClient";

const ChatContainer = styled.div`
  max-height: 600px;
  overflow-y: auto;
  padding: 1rem;
  background-color: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 1rem;
`;

const MessageBubble = styled.div<{ isUser?: boolean }>`
  background-color: ${({ isUser }) => (isUser ? "#d1e7dd" : "#e2e3e5")};
  padding: 10px 14px;
  border-radius: 15px;
  margin: 8px 0;
  max-width: 75%;
  align-self: ${({ isUser }) => (isUser ? "flex-end" : "flex-start")};
  white-space: pre-wrap;
`;

const ChatFooter = styled.div`
  display: flex;
  gap: 10px;
`;

interface Message {
    text: string;
    isUser: boolean;
}

const AI: React.FC = () => {
    const [messages, setMessages] = useState<Message[]>([]);
    const [query, setQuery] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSend = async () => {
        if (!query.trim()) return;

        const newMessages = [...messages, { text: query, isUser: true }];
        setMessages(newMessages);
        setQuery("");
        setLoading(true);

        try {
            // Pass the entire conversation history to the backend
            const res = await apiClient.post(`/queue-agent`, {
                query,
                history: newMessages // Send the full conversation history
            });

            const aiMessage = res.data.answer || "I couldn't find an answer.";

            setMessages((prev) => [...prev, { text: aiMessage, isUser: false }]);
        } catch (err) {
            console.error("Error fetching response:", err);
            setMessages((prev) => [
                ...prev,
                { text: "Error fetching response. Please try again.", isUser: false },
            ]);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container>
            <Row className="justify-content-center">
                <Col md={8}>
                    <Card>
                        <CardBody>
                            <ChatContainer>
                                {messages.map((msg, index) => (
                                    <MessageBubble key={index} isUser={msg.isUser}>
                                        {msg.text}
                                    </MessageBubble>
                                ))}
                                {loading && <Spinner size="sm" color="secondary" />}
                            </ChatContainer>
                            <ChatFooter>
                                <Input
                                    type="text"
                                    value={query}
                                    onChange={(e) => setQuery(e.target.value)}
                                    placeholder="Ask a question..."
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") handleSend();
                                    }}
                                />
                                <Button color="primary" onClick={handleSend} disabled={loading}>
                                    Send
                                </Button>
                            </ChatFooter>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default AI;